import * as moment from "moment";
import fileDownload from "js-file-download";
import { crearPlantillaXLS } from "../../../general/componentes/GenerarPlantillaXLS";
import { EstructuraCentroTrabajo, EstructuraEmpleado, EstructuraEmpresa, EstructuraSede, EstructuraSuraEmpresa } from "./EstructuraEmpresa";
import { 
    cabeceraDatosBasicosEstructuraEmpresas,
    cabeceraSedesEstructuraEmpresas, 
    cabeceraCentrosTrabajoEstructuraEmpresas, 
    cabeceraEmpleadosEstructuraEmpresas, 
    LibroDocumentoXLS 
} from "../../../general/modelo/PlanillasXLS";

export const generarXLSXEstructuraEmpresa = (estructuraEmpresa: EstructuraEmpresa, estructuraSuraEmpresa: EstructuraSuraEmpresa) => {
    const documentoEmpleador = `${estructuraEmpresa.tipoDocumentoEmpleador}${estructuraEmpresa.numeroDocumentoEmpleador}`;
    const excelBlob: Blob = construirXLS(estructuraEmpresa, estructuraSuraEmpresa, documentoEmpleador);
    const nombreArchivo = `reporte_sat_${documentoEmpleador}_${moment(moment.now()).format("DD_MM_YYYY_HHmmss")}.xlsx`;
    fileDownload(
        excelBlob,
        nombreArchivo,
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    );
};

const construirXLS = (estructuraEmpresa: EstructuraEmpresa, estructuraSuraEmpresa: EstructuraSuraEmpresa, documentoEmpleador: string) => {

    /*Libros a generar en el XLS*/
    const libroDatosBasicos = 'Datos Básicos';
    const libroSedes = 'Sedes';
    const libroCT = 'Centros de Trabajo';
    const libroEmpleados = 'Empleados';

    const librosXLS = [];
    librosXLS.push(libroDatosBasicos);
    librosXLS.push(libroSedes);
    librosXLS.push(libroCT);
    librosXLS.push(libroEmpleados);


    const calcularTotales = () => {
        const totalSedes = estructuraEmpresa.sedes.length;
        let totalCT = 0;
        let totalEmpleados = 0;
        if(totalSedes > 0) {
            estructuraEmpresa.sedes.forEach(sede => {
                totalCT += sede.centrosTrabajo.length;
                if(sede.centrosTrabajo.length > 0) {
                    sede.centrosTrabajo.forEach(ct => {
                        totalEmpleados += ct.empleados.length;
                    });
                }
            });
        }
        return {
            totalSedes: totalSedes,
            totalCT: totalCT,
            totalEmpleados: totalEmpleados
        };
    };

    const totales = calcularTotales();

    const datosBasicos = [[
        {value: documentoEmpleador},
        {value: estructuraEmpresa.razonSocial ? estructuraEmpresa.razonSocial : ''},
        {value: estructuraSuraEmpresa ? (estructuraSuraEmpresa.poliza ? estructuraSuraEmpresa.poliza  : '') : 'N/A'},
        {value: estructuraSuraEmpresa ? (estructuraSuraEmpresa.fechaInicio ? estructuraSuraEmpresa.fechaInicio: '') : 'N/A'},
        {value: estructuraEmpresa.tipoPersona ? (`${estructuraEmpresa.tipoPersona === 'N' ? 'Natural' : (estructuraEmpresa.tipoPersona === 'J' ? 'Juridica' : estructuraEmpresa.tipoPersona)}`) : ''},
        {value: estructuraEmpresa.naturalezaJuridica ? estructuraEmpresa.naturalezaJuridica : ''},
        {value: estructuraEmpresa.codigoActividadEconomica ? estructuraEmpresa.codigoActividadEconomica : ''},
        {value: estructuraEmpresa.tipoAportante ? estructuraEmpresa.tipoAportante : ''},
        {value: estructuraEmpresa.claseAportante ?  estructuraEmpresa.claseAportante : ''},
        {value: estructuraEmpresa.correoElectronico ?  estructuraEmpresa.correoElectronico : ''},
        {value: `${estructuraEmpresa.tipoDocumentoRepresentante}${estructuraEmpresa.numeroDocumentoRepresentante}`},
        {value: `${estructuraEmpresa.primerNombreRepresentante} ${estructuraEmpresa.segundoNombreRepresentante} 
                ${estructuraEmpresa.primerApellidoRepresentante} ${estructuraEmpresa.segundoApellidoRepresentante}`},
        {value: totales.totalSedes},
        {value: totales.totalCT},
        {value: totales.totalEmpleados}
    ]];

    const datosSedes = estructuraEmpresa.sedes.map((sede: EstructuraSede) => {
        
        const documentoResponsable = `${sede.tipoDocumentoResponsable}${sede.numeroDocumentoResponsable}`;
        const nombreResponsable = `${sede.primerNombreResponsable} ${sede.segundoNombreResponsable} ${sede.primerApellidoResponsable} ${sede.segundoApellidoResponsable} `;
        const documentoEmpleadorMision = `${estructuraEmpresa.tipoDocumentoEmpleador}${estructuraEmpresa.numeroDocumentoEmpleador}`;
        let totalEmpleados = 0;
        sede.centrosTrabajo.forEach(ct => {
            totalEmpleados += ct.empleados.length;
        });

        return [
            {value: documentoEmpleador},
            {value: sede.codigoSede},
            {value: sede.nombreSede ? sede.nombreSede : ''},
            {value: sede.sedePrincipal ? sede.sedePrincipal : ''},
            {value: sede.municipioSede ? sede.municipioSede : ''},
            {value: sede.direccionSede ? sede.direccionSede : ''},
            {value: sede.zonaUbicacionSede ? ( sede.zonaUbicacionSede === 'U' ? ' URBANA' : (sede.zonaUbicacionSede === 'R' ? ' RURAL' : sede.zonaUbicacionSede) ) : ''},
            {value: sede.telefonoSede ? sede.telefonoSede : ''},
            {value: sede.correoSede ? sede.correoSede : ''},
            {value: documentoResponsable ? documentoResponsable : ''},
            {value: nombreResponsable ? nombreResponsable : ''},
            {value: sede.sedeEmpleadorMision ? sede.sedeEmpleadorMision : ''},
            {value: documentoEmpleadorMision ? documentoEmpleadorMision : ''},
            {value: sede.centrosTrabajo.length},
            {value: totalEmpleados}
        ];
    });

    const datosCT = [];
    estructuraEmpresa.sedes.forEach((sede: EstructuraSede) => {
        sede.centrosTrabajo.forEach((ct: EstructuraCentroTrabajo) => {

            const documentoResponsable = `${ct.tipoDocumentoResponsableCT}${ct.numeroDocumentoResponsableCT}`;
            const nombreResponsable = `${ct.primerNombreResponsableCT} ${ct.segundoNombreResponsableCT} ${ct.primerApellidoResponsableCT} ${ct.segundoApellidoResponsableCT} `;
            datosCT.push([
                {value: documentoEmpleador},
                {value: sede.codigoSede},
                {value: ct.codigoCentroTrabajo ? ct.codigoCentroTrabajo : ''},
                {value: ct.nombreCentroTrabajo ? ct.nombreCentroTrabajo : ''},
                {value: ct.codigoActividadEconomica ? ct.codigoActividadEconomica : ''},
                {value: ct.municipio ? ct.municipio : ''},
                {value: ct.direccionCT ? ct.direccionCT : ''},
                {value: ct.zonaUbicacion ? ( sede.zonaUbicacionSede === 'U' ? ' URBANA' : (sede.zonaUbicacionSede === 'R' ? ' RURAL' : sede.zonaUbicacionSede) ) : ''},
                {value: ct.telefono ? ct.telefono : ''},
                {value: ct.correoElectronico ? ct.correoElectronico : ''},
                {value: documentoResponsable ? documentoResponsable : ''},
                {value: nombreResponsable ? nombreResponsable : ''},
                {value: ct.empleados.length}
            ]);
        });
    });

    const datosEmpleados = [];
    estructuraEmpresa.sedes.forEach((sede: EstructuraSede) => {
        sede.centrosTrabajo.forEach((ct: EstructuraCentroTrabajo) => {
            ct.empleados.forEach((empleado: EstructuraEmpleado) => {

                const documentoEmpleado = `${empleado.tipoDocumentoIdentificacion}${empleado.numeroDocumentoIdentificacion}`;
                const nombreEmpleado = `${empleado.primerNombreTrabajador} ${empleado.segundoNombreTrabajador} ${empleado.primerApellidoTrabajador} ${empleado.segundoApellidoTrabajador} `;

                datosEmpleados.push([
                    {value: documentoEmpleador},
                    {value: sede.codigoSede},
                    {value: ct.codigoCentroTrabajo ? ct.codigoCentroTrabajo : ''},
                    {value: documentoEmpleado ? documentoEmpleado : ''},
                    {value: nombreEmpleado ? nombreEmpleado : ''},
                    {value: empleado.fechaInicio ? empleado.fechaInicio : ''},
                    {value: empleado.fechafin ? empleado.fechafin : ''},
                    {value: empleado.tipoCotizante ? empleado.tipoCotizante : ''},
                    {value: empleado.subtipoCotizante ? empleado.subtipoCotizante : ''},
                    {value: empleado.ibc ? empleado.ibc : ''},
                    {value: empleado.tipoSalario ? empleado.tipoSalario : ''},
                    {value: empleado.fechaNacimiento ? empleado.fechaNacimiento : ''},
                    {value: empleado.sexoTrabajador ? empleado.sexoTrabajador : ''},
                    {value: empleado.epsTrabajador ? empleado.epsTrabajador : ''},
                    {value: empleado.afpTrabajador ? empleado.afpTrabajador : ''}
                ]);
            });
        });
    });

    /*Datos para generar el XLS*/
    const datosLibrosXLS: LibroDocumentoXLS[] = [{
        nombreLibro: libroDatosBasicos,
        cabecera: cabeceraDatosBasicosEstructuraEmpresas(),
        datos: datosBasicos,
    }, {
        nombreLibro: libroSedes,
        cabecera: cabeceraSedesEstructuraEmpresas(),
        datos: datosSedes,
    }, {
        nombreLibro: libroCT,
        cabecera: cabeceraCentrosTrabajoEstructuraEmpresas(),
        datos: datosCT,
    }, {
        nombreLibro: libroEmpleados,
        cabecera: cabeceraEmpleadosEstructuraEmpresas(),
        datos: datosEmpleados,
    }];

    return crearPlantillaXLS(librosXLS, datosLibrosXLS);
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/estructura_empresas/modelo/EstructuraEmpresaXLS.tsx